import r, { forwardRef as u } from "react";
import { useTheme as d } from "@chakra-ui/react";
import { Icon as l } from "../icon/icon.js";
import "@loadable/component";
import "react-icons/md";
import { Button as h } from "./button.js";
import "react-icons/fa";
import "./masthead-button.js";
import "@chakra-ui/system";
import "framer-motion";
import "react-icons/fi";
import "react-icons/hi";
import "react-icons/ri";
import "react-icons/io5";
import "./close-button.js";
const q = u(
  ({
    icon: t,
    children: o,
    iconFill: m,
    iconWidth: i,
    iconHeight: e,
    isRounded: p,
    layout: n = "horizontal",
    ...a
  }, c) => {
    const { sp02: f } = d(), s = n === "horizontal" && o ? f : 0;
    return /* @__PURE__ */ r.createElement(h, { ref: c, borderRadius: p ? "50%" : void 0, ...a }, /* @__PURE__ */ r.createElement(
      l,
      {
        as: t,
        color: m,
        w: i,
        h: e,
        mr: s,
        role: "img",
        "aria-hidden": "true"
      }
    ), o);
  }
);
export {
  q as IconButton
};
